var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 7.43685C5.15051 7.43685 3.64551 5.93185 3.64551 4.08268C3.64551 2.23352 5.15051 0.728516 6.99967 0.728516C8.84884 0.728516 10.3538 2.23352 10.3538 4.08268C10.3538 5.93185 8.84884 7.43685 6.99967 7.43685ZM6.99967 1.60352C5.63467 1.60352 4.52051 2.71768 4.52051 4.08268C4.52051 5.44768 5.63467 6.56185 6.99967 6.56185C8.36467 6.56185 9.47884 5.44768 9.47884 4.08268C9.47884 2.71768 8.36467 1.60352 6.99967 1.60352Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0109 13.2708C11.7718 13.2708 11.5734 13.0725 11.5734 12.8333C11.5734 10.8208 9.52009 9.1875 7.00009 9.1875C4.48009 9.1875 2.42676 10.8208 2.42676 12.8333C2.42676 13.0725 2.22842 13.2708 1.98926 13.2708C1.75009 13.2708 1.55176 13.0725 1.55176 12.8333C1.55176 10.3425 3.99592 8.3125 7.00009 8.3125C10.0043 8.3125 12.4484 10.3425 12.4484 12.8333C12.4484 13.0725 12.2501 13.2708 12.0109 13.2708Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.3e94fa0551b70946bbfedbbc225fd6b4.svg";
export { ForwardRef as ReactComponent };